import { DatePicker } from '@mui/x-date-pickers'
import { Stack } from '@mui/material'
import { format, parseISO } from 'date-fns'
import { CONTROLS } from '~/components/Charts/chrome/chartChrome'

interface Props {
  fromIso: string
  toIso: string
  onChange: (next: { fromIso: string; toIso: string }) => void
  /** Optional lower bound for the From picker only (derives from the model floor). */
  minDate?: Date
}

export function TimeRangePicker({ fromIso, toIso, onChange, minDate }: Props) {
  return (
    // flexWrap: inside the Timeframe zone of the two-row ControlBand, the To picker wraps
    // below From on narrow zones instead of overflowing the zone edge.
    <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
      <DatePicker
        label={CONTROLS.from}
        value={parseISO(fromIso)}
        minDate={minDate}
        onChange={(d) => d && onChange({ fromIso: format(d, 'yyyy-MM-dd'), toIso })}
        slotProps={{ textField: { size: 'small', sx: { width: 140 } } }}
      />
      <DatePicker
        label={CONTROLS.to}
        value={parseISO(toIso)}
        onChange={(d) => d && onChange({ fromIso, toIso: format(d, 'yyyy-MM-dd') })}
        slotProps={{ textField: { size: 'small', sx: { width: 140 } } }}
      />
    </Stack>
  )
}
